import React from 'react';
import { CtaBlock } from '../CtaButton';
import { AssuranceRow } from './AssuranceRow';
import { MOCKUP_URL } from '../../data/images';
export function FinalSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-forest px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-101" data-mp="9uwka1004tw1">
      <div className="mx-auto max-w-4xl" data-id="element-102" data-mp="53o5sqjteic0">
        <h2 id="final-heading" className="mx-auto max-w-3xl font-display text-[2.4rem] font-bold leading-[1.06] text-brand-ivory sm:text-[3.2rem]" data-id="element-103" data-mp="52leihikydvk">
          Votre prochain cours ne devrait pas commencer par{' '}
          <em className="italic text-brand-butter" data-id="element-104" data-mp="stijtbfvecxu">des heures de préparation.</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-ivory/75 sm:text-[16px]" data-id="element-105" data-mp="nuo0m8dzqmd7">
          Vous avez déjà l’expertise. Maintenant, donnez-vous le système pour l’enseigner.
        </p>

        <img src={MOCKUP_URL} alt="Le système complet Nail Educator Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain" style={{
        filter: 'drop-shadow(0 30px 40px rgba(0, 0, 0, 0.45))'
      }} data-id="element-106" data-mp="2pmkbrgw8xu7g" />

        <p className="mt-8 font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-butter" data-id="element-107" data-mp="2zgcznce4hcoj">
          6 volumes + 5 bonus · Accès numérique immédiat
        </p>

        <CtaBlock label="Oui ! Donnez-moi le système" tone="dark" className="mt-6" data-id="element-108" data-mp="397r6k58elerp" />
        <AssuranceRow tone="dark" className="mt-5" data-id="element-109" data-mp="3e6avmeian6oa" />

        <p className="mx-auto mt-12 max-w-xl font-display text-[1.4rem] italic leading-snug text-brand-ivory/85" data-id="element-110" data-mp="3j6gp8084j390">
          Moins de temps à préparer. Plus de structure pour enseigner.
        </p>
      </div>
    </section>;
}